export interface RuleGroupList {
  id?: number;
  /**
   * 规则组编号
   */
  code?: string;
  /**
   * 规则组名称
   */
  name?: string;
  /**
   * 规则数量
   */
  ruleCount?: number;
}

export enum AlarmStatus {
  ABLE = 0,
  DISABLE = 1,
}

export const alarmStatusDisplay: Record<AlarmStatus, string> = {
  [AlarmStatus.ABLE]: '启用',
  [AlarmStatus.DISABLE]: '禁用',
};

// 报警状态下拉
export const alarmStatusOptions: { label: string; value: AlarmStatus }[] = (
  Object.values(AlarmStatus) as Array<string | number>
)
  .filter(v => typeof v === 'number')
  .map(v => {
    const val = v as AlarmStatus;
    return { value: val, label: alarmStatusDisplay[val] };
  });